(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lb-casino/assets/javascripts/find-page.js') >= 0) return;  svs.modules.push('/modules/lb-casino/assets/javascripts/find-page.js');
"use strict";


class FindPage {
  constructor() {
    if (!svs.lb_casino.data.renderModel.gameCacheEmpty) {
      new svs.components.casino.Search();
    }
    new svs.components.casino.Categories(svs.lb_casino.data.renderModel.casinoSection);
  }
}
setGlobal('svs.lb_casino.initFindPage', () => new FindPage());

 })(window);